export const QueryKeys = {
  users: 'users',
  roles: 'roles',
  permissions: 'permissions',
  companies: 'companies',
  companyLocalPrograms: 'companyLocalPrograms',
  databases: 'databases',
  branches: 'branches',
  currencies: 'currencies',
  branchCashBoxes: 'branchCashBoxes',
  posCashBoxes: 'posCashBoxes',
  pos: 'pos',
  customerAccountsForBranches: 'customerAccountsForBranches',
  mikroBranches: 'mikroBranches',
  mikroPoses: 'mikroPoses',
  mikroPrices: 'mikroPrices',
  mikroResponsibilityCenters: 'mikroResponsibilityCenters',
  mikroWarehouses: 'mikroWarehouses',
  mikroCurrencyRates: 'mikroCurrencyRates',
  branchWarehouses: 'branchWarehouses',
  barkodTanimlari: 'barkodTanimlari',
  barkodTanimlariWithBarStokkodu: 'barkodTanimlariWithBarStokkodu',

  stokFiyatDegisiklikleri: 'stokFiyatDegisiklikleri',
  stokKategorileri: 'stokKategorileri',
  stoklar: 'stoklar',
  stokMarkalari: 'stokMarkalari',
  stokSatisFiyatListeleri: 'stokSatisFiyatListeleri',
  stokSatisFiyatListeTanimlari: 'stokSatisFiyatListeTanimlari',
  stokSektorleri: 'stokSektorleri',
  stokUreticileri: 'stokUreticileri',

  StoklarViewByStoKod: 'StoklarViewByStoKod',
  StoklarViewByUrtIsmi: 'StoklarViewByUrtIsmi',
  StoklarViewByKtgIsim: 'StoklarViewByKtgIsim',
  StoklarViewBySktrIsmi: 'StoklarViewBySktrIsmi',
  StoklarViewByMrkIsmi: 'StoklarViewByMrkIsmi',

  vwGendataVergi: 'vwGendataVergi',

  mikroDBSorgulariDoviz: 'mikroDBSorgulariDoviz',
  mikroDBSorgulariUlkeler: 'mikroDBSorgulariUlkeler',
  mikroDBSorgulariIller: 'mikroDBSorgulariIller',
  mikroDBSorgulariIlceler: 'mikroDBSorgulariIlceler',
  mikroDBSorgulariYerelBankaKodlari: 'mikroDBSorgulariYerelBankaKodlari',
  mikroDBSorgulariHasCariHesapHareket: 'mikroDBSorgulariHasCariHesapHareket',
  stokHareketleriViewBySthGuid: 'stokHareketleriViewBySthGuid',
  stokHareketleriViewBySthStokKod: 'stokHareketleriViewBySthStokKod',
  stokHareketleriViewByStoIsim: 'stokHareketleriViewByStoIsim',

  cariHesaplarViewByCariKod: 'cariHesaplarViewByCariKod',
  cariHesaplarViewByKurIsmi: 'cariHesaplarViewByKurIsmi',
  cariHesaplarViewByCariUnvan1: 'cariHesaplarViewByCariUnvan1',
  cariHesaplar: 'cariHesaplar',

  cariHesapGruplari: 'cariHesapGruplari',

  cariHesapAdresleri: 'cariHesapAdresleri',

  bankalarViewByBanKod: 'bankalarViewByBanKod',
  bankalarViewByKurIsmi: 'bankalarViewByKurIsmi',
  bankalar: 'bankalar',

  firmaKrediKartiTanimlariViewByFkkKod: 'firmaKrediKartiTanimlariViewByFkkKod',
  firmaKrediKartiTanimlariViewByKurIsmi: 'firmaKrediKartiTanimlariViewByKurIsmi',
  firmaKrediKartiTanimlari: 'firmaKrediKartiTanimlari',

  kasalarViewByKasKod: 'kasalarViewByKasKod',
  kasalarViewByKurIsmi: 'kasalarViewByKurIsmi',
  kasalar: 'kasalar',

  hizmetHesaplariViewByHizKod: 'hizmetHesaplariViewByHizKod',
  hizmetHesaplariViewByVrYuzde: 'hizmetHesaplariViewByVrYuzde',
  hizmetHesaplariViewBykurIsmi: 'hizmetHesaplariViewBykurIsmi',
  hizmetHesaplari: 'hizmetHesaplari',

  masrafHesaplariViewByHisKod: 'masrafHesaplariViewByHisKod',
  masrafHesaplariViewByVrYuzde: 'masrafHesaplariViewByVrYuzde',
  masrafHesaplariViewBykurIsmi: 'masrafHesaplariViewBykurIsmi',
  masrafHesaplari: 'masrafHesaplari',

  hizmetMasrafGruplari: 'hizmetMasrafGruplari',
  hizmetMasrafSiniflari: 'hizmetMasrafSiniflari',
  hizmetMasrafTipleri: 'hizmetMasrafTipleri',

  cariHesapHareketleriFOByKey: 'cariHesapHareketleriFOByKey',
  cariHesapHareketleriFOByChaTarihi: 'cariHesapHareketleriFOByChaTarihi',
  cariHesapHareketleriFOByCariUnvan1: 'cariHesapHareketleriFOByCariUnvan1',
  cariHesapHareketleriFOByFaturaTipi: 'cariHesapHareketleriFOByFaturaTipi',
  cariHesapHareketleriFOBySubeAdi: 'cariHesapHareketleriFOBySubeAdi',
  cariHesapHareketleriFOByDepAdi: 'cariHesapHareketleriFOByDepAdi',
  stokHareketleriFO: 'stokHareketleriFO',

  cariHareketOdemeVadeleri: 'cariHareketOdemeVadeleri',

  depolar: 'depolar',

  aktarim: 'aktarim',
};
